/* Decorative adapter for the installed Pandectes banner. No consent API,
 * storage or click handling. Stop observing as soon as its text is ready. */
function decorateBanner() {
  const banner = document.getElementById('pandectes-banner');
  const message = banner?.querySelector('.cc-message');
  if (!message) return false;
  const firstText = document.createTreeWalker(message, NodeFilter.SHOW_TEXT).nextNode();
  if (!firstText) return false;
  firstText.textContent = firstText.textContent.replace(/^(\s*)🍪\uFE0F?\s*/, '$1');
  banner.classList.add('mabe-privacy-symbol');
  return true;
}
if (!decorateBanner()) {
  const observer = new MutationObserver(() => {
    if (decorateBanner()) {
      observer.disconnect();
      clearTimeout(deadline);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  // Do not keep a document observer when the app is disabled or unavailable.
  const deadline = setTimeout(() => observer.disconnect(), 15000);
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    clearTimeout(deadline);
  }, { once: true });
}
